module.exports = __webpack_public_path__ + "static/media/Sidney-Velvet--ED-A-preferred.cbe864dd.jpg";